
/**
 * Creates a mapping of menu item keys to their corresponding paths.
 * This function traverses the menu items recursively and builds a map where each key is the menu item's key and the value is its path.
 * @param {Array} menuItems - The array of menu items to traverse.
 * @return {Object} A mapping of menu item keys to paths.
 */

export const createMenuPathsMap = (menuItems) => {
    const pathsMap = {};
    const traverse = (items) => {
        if (!items) return;
        items.forEach((item) => {
            if (item.key && item.path && item.onClick === undefined) {
                pathsMap[item.key] = item.path;
            }
            if (item.children) {
                traverse(item.children);
            }
        });
    };
    traverse(menuItems);
    return pathsMap;
};


/**
 *  Creates a mapping of menu item keys to their corresponding levels in the menu hierarchy.
 * @param {Array|any} items1  - The array of menu items to traverse.
 * @returns  {Object} A mapping of menu item keys to their levels in the menu hierarchy.
 */
export const getLevelKeys = (items1) => {
    const key = {};
    const func = (items2, level = 1) => {
        items2.forEach((item) => {
            if (item.key) {
                key[item.key] = level;
            }
            if (item.children) {
                func(item.children, level + 1);
            }
        });
    };
    func(items1);
    return key;
};